import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDateFnsLocale } from '@hooks/useDateFnsLocale'
import { useGetTreatmentInfo } from '@hooks/useGetTreatmentInfo'
import { useLanguage } from '@hooks/useLanguage'
import { getAppointmentDateAndTimeStrings } from './TreatmentInfo.helpers'

export const AppointmentDateAndTime = () => {
  const { t } = useTranslation()
  const language = useLanguage()
  const { selectedAppointment } = useGetTreatmentInfo()
  const locale = useDateFnsLocale()
  const [appointmentDate, appointmentTime] = getAppointmentDateAndTimeStrings(selectedAppointment, language, locale)

  return (
    <>
      <span>{appointmentDate}</span>
      <span> {t('at')} </span>
      <span>{appointmentTime}</span>
    </>
  )
}
